
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 511.995 511.995","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M308.167 241.52c0-28.766-23.403-52.169-52.17-52.169s-52.17 23.403-52.17 52.169c0 28.767 23.403 52.17 52.17 52.17s52.17-23.404 52.17-52.17zm-52.169 22.169c-12.225 0-22.17-9.945-22.17-22.17 0-12.224 9.945-22.169 22.17-22.169s22.17 9.945 22.17 22.169c-.001 12.225-9.946 22.17-22.17 22.17z"}}),_c('path',{attrs:{"d":"M425.684 424.352V292.03l-51.65-32.948a313.08 313.08 0 00-1.117-43.191c-7.162-74.973-41.384-144.771-96.362-196.535L255.998 0 235.44 19.356c-54.978 51.765-89.2 121.563-96.362 196.535a313.08 313.08 0 00-1.117 43.191l-51.65 32.948v132.321l90.003-28.282a307.392 307.392 0 0012.017 19.945v62.315h30v-48.333h22.667v23.252h30v-23.252h22.667v48.333h30v-62.315a307.123 307.123 0 0012.017-19.945zm-30-115.874v75.001l-46.66-14.662a311.297 311.297 0 0021.762-76.222zM255.99 41.198c27.301 25.706 48.392 55.971 63.081 88.684H192.918c14.687-32.713 35.775-62.979 63.072-88.684zM116.311 383.479v-75.001l24.898-15.883a311.21 311.21 0 0021.762 76.222zm124.687-10.983v27.499h-27.316c-47.563-72.299-57.394-161.126-32.242-240.114h149.112c25.156 78.987 15.325 167.815-32.238 240.114h-27.316v-27.499zM240.998 483.495h30v28.5h-30z"}})])
          )
        }
      }
    